export default "__VITE_ASSET__2ede65a8__"